export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const SHOP_API = `${BACKEND}/api/shop`;
export const PLACEHOLDER = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"><rect width="400" height="300" fill="#F3F0EA"/><circle cx="200" cy="140" r="46" fill="none" stroke="#0A5C2C" stroke-width="6"/><text x="200" y="152" font-family="Arial" font-size="34" font-weight="700" fill="#0A5C2C" text-anchor="middle">NDP</text><text x="200" y="225" font-family="Arial" font-size="16" fill="#6B7280" text-anchor="middle">Image coming soon</text></svg>');

export const img = (u) => (!u ? PLACEHOLDER : u.startsWith('/api/') ? `${BACKEND}${u}` : u);

const BN_DIGITS = '০১২৩৪৫৬৭৮৯';
export const bnNum = (s) => String(s).replace(/\d/g, (d) => BN_DIGITS[d]);
export const taka = (n, lang) => {
  if (n === null || n === undefined) return '';
  const s = `৳${Number(n).toLocaleString('en-IN')}`;
  return lang === 'bn' ? bnNum(s) : s;
};
export const num = (n, lang) => (lang === 'bn' ? bnNum(n) : String(n));

export const CATEGORIES = [
  { id: 'apparel', en: 'Apparel', bn: 'পোশাক' },
  { id: 'accessories', en: 'Accessories', bn: 'আনুষঙ্গিক' },
  { id: 'home', en: 'Home & Office', bn: 'গৃহ ও অফিস' },
  { id: 'flags', en: 'Flags', bn: 'পতাকা' },
  { id: 'campaign', en: 'Campaign', bn: 'প্রচারণা' },
  { id: 'kids', en: 'Kids', bn: 'শিশু' },
  { id: 'women', en: 'Women', bn: 'নারী' },
  { id: 'gifts', en: 'Gifts', bn: 'উপহার' },
];

export const SWATCHES = {
  Golapi: ['#F7CAC9', 'গোলাপি'], Peach: ['#FFBE98', 'পিচ'], Holud: ['#F0C05A', 'হলুদ'], Akashi: ['#92A8D1', 'আকাশি'],
  Probal: ['#FF6F61', 'প্রবাল'], Rani: ['#BB2649', 'রানি'], Mehedi: ['#955251', 'মেহেদি'], Orchid: ['#AD5E99', 'অর্কিড'],
  Aparajita: ['#6667AB', 'অপরাজিতা'], Neel: ['#0F4C81', 'নীল'], Ivory: ['#F4EFE4', 'আইভরি'], White: ['#FFFFFF', 'সাদা'],
  'Heritage green': ['#0A5C2C', 'হেরিটেজ সবুজ'],
};
export const swatchParts = (c) => c.split('/').map((x) => x.trim()).map((x) => SWATCHES[x] || SWATCHES[x[0].toUpperCase() + x.slice(1)]);
export const canSwatch = (c) => swatchParts(c).every(Boolean);

export const BANNERS = [
  { key: 'nakshi', col: 'Nakshi', alt: { en: 'The Nakshi Collection for women — saree, kurti and cardigan in Nakshi colours', bn: 'নারীদের জন্য নকশি কালেকশন — শাড়ি, কুর্তি ও কার্ডিগান' } },
  { key: 'gifts', col: 'Gifts', alt: { en: 'Gifts & Ceremony — the NDP Executive gift set and baby tiger', bn: 'উপহার ও অনুষ্ঠান — এনডিপি এক্সিকিউটিভ উপহার সেট' } },
];

export const COLLECTIONS = [
  { id: '', en: 'All', bn: 'সব' },
  { id: 'Heritage', en: 'Heritage', bn: 'ঐতিহ্য' },
  { id: 'Tricolour', en: 'Tricolour', bn: 'ত্রিবর্ণ' },
  { id: 'Campaign', en: 'Campaign', bn: 'প্রচারণা' },
  { id: 'Official', en: 'Official', bn: 'অফিসিয়াল' },
  { id: 'Home & Office', en: 'Home & Office', bn: 'গৃহ ও অফিস' },
  { id: 'Kids', en: 'Kids', bn: 'শিশু' },
  { id: 'Nakshi', en: 'Nakshi', bn: 'নকশি' },
  { id: 'Gifts', en: 'Gifts', bn: 'উপহার' },
];

export const STATUS_FLOW = ['placed', 'confirmed', 'packed', 'shipped', 'delivered'];
export const STATUS_LABEL = {
  placed: { en: 'Placed', bn: 'গৃহীত' }, confirmed: { en: 'Confirmed', bn: 'নিশ্চিত' }, packed: { en: 'Packed', bn: 'প্যাক করা' },
  shipped: { en: 'Shipped', bn: 'পাঠানো হয়েছে' }, delivered: { en: 'Delivered', bn: 'ডেলিভারি সম্পন্ন' },
  cancelled: { en: 'Cancelled', bn: 'বাতিল' }, returned: { en: 'Returned', bn: 'ফেরত' },
};

export const DIVISIONS = {
  Barisal: ['Barguna', 'Barisal', 'Bhola', 'Jhalokati', 'Patuakhali', 'Pirojpur'],
  Chittagong: ['Bandarban', 'Brahmanbaria', 'Chandpur', 'Chittagong', 'Comilla', "Cox's Bazar", 'Feni', 'Khagrachhari', 'Lakshmipur', 'Noakhali', 'Rangamati'],
  Dhaka: ['Dhaka', 'Faridpur', 'Gazipur', 'Gopalganj', 'Kishoreganj', 'Madaripur', 'Manikganj', 'Munshiganj', 'Narayanganj', 'Narsingdi', 'Rajbari', 'Shariatpur', 'Tangail'],
  Khulna: ['Bagerhat', 'Chuadanga', 'Jessore', 'Jhenaidah', 'Khulna', 'Kushtia', 'Magura', 'Meherpur', 'Narail', 'Satkhira'],
  Mymensingh: ['Jamalpur', 'Mymensingh', 'Netrokona', 'Sherpur'],
  Rajshahi: ['Bogra', 'Chapainawabganj', 'Joypurhat', 'Naogaon', 'Natore', 'Pabna', 'Rajshahi', 'Sirajganj'],
  Rangpur: ['Dinajpur', 'Gaibandha', 'Kurigram', 'Lalmonirhat', 'Nilphamari', 'Panchagarh', 'Rangpur', 'Thakurgaon'],
  Sylhet: ['Habiganj', 'Moulvibazar', 'Sunamganj', 'Sylhet'],
};

export const PAY_LOGOS = ['bKash', 'Nagad', 'VISA', 'Mastercard', 'COD'];

export const SIZE_TABLES = [
  { title: 'T-shirts (Tipped, Tiger, Campaign)', cols: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['½ chest (1 cm below armhole)', 48, 51, 54, 57, 60, 63], ['Body length (HPS)', 69, 72, 74, 76, 78, 80], ['Sleeve length (shoulder)', 19, 20, 21, 22, 23, 24]] },
  { title: 'Polo shirt', cols: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['½ chest', 50, 53, 56, 59, 62, 65], ['Body length (HPS)', 70, 72, 74, 76, 78, 80], ['Sleeve length', 21, 22, 23, 24, 25, 26]] },
  { title: 'Hoodies, quarter-zip, sweater', cols: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['½ chest', 54, 57, 60, 63, 66, 69], ['Body length (HPS)', 68, 70, 72, 74, 76, 78], ['Sleeve length (shoulder)', 62, 63, 64, 65, 66, 67]] },
  { title: 'Oxford shirt', cols: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['½ chest', 53, 56, 59, 62, 65, 68], ['Back length', 74, 76, 78, 80, 82, 84], ['Sleeve length', 62, 63, 64, 65, 66, 67]] },
  { title: 'Panjabi', cols: ['38', '40', '42', '44', '46'], rows: [['Length (HPS)', 97, 102, 107, 112, 117], ['Chest (full)', 102, 104, 106, 108, 110], ['Sleeve length', 60, 61, 62, 63, 64]] },
  { title: "Kids' tee and hoodie", cols: ['2-4', '4-6', '6-8', '8-10', '10-12'], rows: [['½ chest', 32, 35, 38, 41, 44], ['Body length', 41, 45, 49, 53, 57], ['Sleeve (tee / hoodie)', '11/34', '12/38', '13/42', '14/46', '15/50']] },
];
